import { useState, useEffect } from "react";
import {
    Calendar as BigCalendar,
    dayjsLocalizer,
    SlotInfo,
    View,
} from "react-big-calendar";

// import { Button } from "../../ui/button";
import "react-big-calendar/lib/css/react-big-calendar.css";
import dayjs from "dayjs";
import "dayjs/locale/es";
import { fetchAxiosToken } from "../../../helpers/fetchAxiosToken";
import { useAppSelector } from "../../../hooks/hooks";
import { ShiftNewCalendarModal } from "./ShiftNewCalendarModal";
import ModalHorario from "../ModalHorario";
// import { ShiftCalendarModal } from "./ShiftCalendarModal";
// import { ShiftNewCalendarModal } from "./ShiftNewCalendarModal";
// import { fetchAxiosToken } from "@/helpers/fetchAxiosToken";
// import { TimetablesEdit } from "../../professional/modalEdit/TimetablesEdit";
import {
    ScheduleBlocked,
    UpdateScheduleBlocked,
} from "./UpdateScheduleBlocked";
import { UpdateDateBlocked } from "./UpdateDateBlocked";
import { ShiftCalendarModal } from "./ShiftCalendarModal";
// import { useAppDispatch, useAppSelector } from "@/hooks/hooks";

// import google_calendar from "../../../img/google_calendar.png";
// import { toast } from "@/components/ui/use-toast";

// import { verifyToken } from "@/redux/reducers/authReducer";

dayjs.locale("es");

export interface MyEvents {
    title: string;
    start: string;
    end: string;
    data: Data;
}

export interface Data {
    id: string;
    type: string;
    state?: string;
    extra_note?: string;
    typeTimes?: string;
    typeHours?: string;
    id_recurrent: string | null;
}

const Tooltip = ({ content, show }: any) => (
    <div
        className={`absolute bg-black text-white text-xs rounded py-1 px-2 top-8 ${
            show ? "block" : "hidden"
        }`}>
        {content}
    </div>
);

export const Calendar = () => {
    const localizer = dayjsLocalizer(dayjs);
    const [edit, setEdit] = useState<ScheduleBlocked | null>(null);
    const [editBlockedDay, setEditBlockedDay] = useState(false);
    const [editSchedule, setEditSchedule] = useState<ScheduleBlocked | null>(
        null
    );
    const [editDateBlocked, setEditDateBlocked] =
        useState<ScheduleBlocked | null>(null);
    const [newShift, setNewShift] = useState<null | Date>(null);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [blockedDays, setBlockedDays] = useState<number[]>([]);
    const [blockedDates, setBlockedDates] = useState<Date[]>([]);
    const [blockedDatesInfo, setBlockedDatesInfo] = useState<MyEvents[]>([]);
    const [myEventsList, setMyEventsList] = useState<MyEvents[]>([]);
    const [tooltipContent, setTooltipContent] = useState("");
    const [tooltipVisible, setTooltipVisible] = useState(false);
    const [loadingCalendar, setLoadingCalendar] = useState(false);
    const [emailGoogleCalendar, setEmailGoogleCalendar] = useState("");
    const { id } = useAppSelector((state) => state.usuario_logeado);
    const [modalHorario, setModalHorario] = useState(false);

    const getEvents = async () => {
        const dataEvent = await fetchAxiosToken({
            url: `/visitas_agendadas/getVisitasAgendadas/${id}?page=1`,
            method: "get",
        });
        console.log("dataEvent", dataEvent);
        setMyEventsList(
            dataEvent.reserves.map((event: any) => ({
                ...event,
                start: new Date(event.start),
                end: new Date(event.end),
            }))
        );

        setBlockedDates(
            dataEvent.notAvailable.map((day: any) => new Date(day.start))
        );

        const schedules = dataEvent.schedules;
        const blockedDays = Object.keys(schedules).filter(
            (key) => schedules[key] === 0
        );
        setBlockedDatesInfo(dataEvent.notAvailable);

        setBlockedDays(blockedDays.map((day) => parseInt(day)));
    };

    const putCalendar = async () => {
        try {
            const userId = id; // el id del usuario
            const subdomain = window.location.hostname.split(".")[0]; // Obtén el subdominio actual
            window.location.href = `https://www.consultaya.app/google-authenticate?userId=${userId}&subdomain=${subdomain}`;
        } catch (error) {
            console.error("Error fetching auth URL:", error);
        }
    };

    const getInfoGoogleCalendar = async () => {
        const data = await fetchAxiosToken({
            url: `/google-calendar/info`,
            method: "post",
            body: {
                id,
            },
        });

        setEmailGoogleCalendar(data.payload);
    };

    const components = {
        event: (props: any) => (
            <div className="flex items-center gap-1">
                <p
                    className={` w-[10px] h-[10px]  rounded-full
                           ${
                               props.event.data?.state === "Agendado"
                                   ? "bg-lime-400"
                                   : props.event.data?.state === "Por confirmar"
                                   ? "bg-orange-400"
                                   : props.event.data?.type === "notAvailable"
                                   ? "bg-red-400"
                                   : "bg-teal-400"
                           }`}></p>
                <p className="text-xs"> {props.title}</p>
            </div>
        ),
    };

    const blockDayStyle = (event: Date) => {
        const day = dayjs(event).get("day");
        const isBlockedDate = blockedDates.some((date) =>
            dayjs(date).isSame(dayjs(event), "day")
        );
        const isBlockedDay = blockedDays.includes(day);
        if (isBlockedDate || isBlockedDay) {
            return { className: "bg-red-100" };
        }
        return {};
    };

    const onSelectSlot = (slot: SlotInfo) => {
        if (slot.action == "select" && windowWidth > 640) return;
        const day = dayjs(slot.start).get("day");
        const isBlockedDate = blockedDates.some((date) =>
            dayjs(date).isSame(dayjs(slot.start), "day")
        );
        const isBlockedDay = blockedDays.includes(day);
        if (isBlockedDay) {
            setEditBlockedDay(true);
            return;
        }
        console.log("isBlockedDate", isBlockedDate);

        if (isBlockedDate) {
            console.log("blockedDatesInfo", blockedDatesInfo);
            const event = blockedDatesInfo.find((date) =>
                dayjs(date.start).isSame(dayjs(slot.start), "day")
            );
            console.log("event", event);
            if (!event) return;
            setEditDateBlocked({
                start: event?.start,
                end: event?.start,
                id: event?.data.id,
            });
            return;
        }
        setNewShift(slot.start);
    };

    const onSelectEvent = (event: any) => {
        if (event.data.type === "notAvailable") {
            setEditSchedule({
                start: event.start,
                end: event.end,
                id: event.data.id,
            });
            return;
        }
        setEdit({ start: event.start, end: event.end, id: event.data.id });
    };

    useEffect(() => {
        getEvents();

        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const views: View[] =
        windowWidth > 1280 ? ["month", "week", "day"] : ["month", "day"];

    const handleMouseLeave = () => {
        setTooltipVisible(false);
    };

    const handleClick = (content: any) => {
        setTooltipContent(content);

        setTooltipVisible(!tooltipVisible);
    };

    const renderShowMore = (count: number) => {
        const element = (
            <p className="text-xs text-blue-consulta-700">+{count} turnos</p>
        );
        return `+${count} turnos`;
    };

    return (
        <div className="relative w-full">
            <div className="flex justify-end w-full gap-4 px-8 pt-6">
                {/* <Button
                    onClick={() => setEditBlockedDay(true)}
                    type="button"
                    className="select-none bg-blue-consulta-800 ">
                    Editar consultorio
                </Button> */}
                <div
                    onClick={() => setModalHorario(true)}
                    className="p-2 px-5 text-white bg-blue-500 rounded-lg cursor-pointer hover:scale-105">
                    Editar Horarios
                </div>
            </div>

            <div className="w-full h-[120vh] xs:h-[90vh] px-2 xs:px-8 pb-36 pt-8 mb-32 xs:mb-20 md723:mb-0 xs550:pb-8 xs550:pt-4 font-poppins-regular select-none">
                <ModalHorario
                    modalHorario={modalHorario}
                    setModalHorario={setModalHorario}
                    getEvents={getEvents}
                />
                {/* {editBlockedDay && (
                    <TimetablesEdit
                        edit={editBlockedDay}
                        setEdit={setEditBlockedDay}
                        getEvents={getEvents}
                    />
                )}  */}
                {edit && (
                    <ShiftCalendarModal
                        edit={edit}
                        setEdit={setEdit}
                        getEvents={getEvents}
                    />
                )}

                {editSchedule && (
                    <UpdateScheduleBlocked
                        edit={editSchedule}
                        setEdit={setEditSchedule}
                        getEvents={getEvents}
                    />
                )}
                {editDateBlocked && (
                    <UpdateDateBlocked
                        edit={editDateBlocked}
                        setEdit={setEditDateBlocked}
                        getEvents={getEvents}
                    />
                )}

                {newShift && (
                    <ShiftNewCalendarModal
                        edit={newShift}
                        setEdit={setNewShift}
                        getEvents={getEvents}
                    />
                )}
                <div className="relative flex items-center justify-center w-full gap-2 mb-4">
                    <Tooltip content={tooltipContent} show={tooltipVisible} />
                    <div
                        onMouseLeave={handleMouseLeave}
                        onClick={() =>
                            handleClick(
                                "Horario no disponible para agendar turnos"
                            )
                        }
                        className="flex items-center justify-center w-8 h-6 text-white bg-red-400 rounded-lg cursor-pointer">
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM8.24992 4.49999C8.24992 4.9142 7.91413 5.24999 7.49992 5.24999C7.08571 5.24999 6.74992 4.9142 6.74992 4.49999C6.74992 4.08577 7.08571 3.74999 7.49992 3.74999C7.91413 3.74999 8.24992 4.08577 8.24992 4.49999ZM6.00003 5.99999H6.50003H7.50003C7.77618 5.99999 8.00003 6.22384 8.00003 6.49999V9.99999H8.50003H9.00003V11H8.50003H7.50003H6.50003H6.00003V9.99999H6.50003H7.00003V6.99999H6.50003H6.00003V5.99999Z"
                                fill="currentColor"
                                fillRule="evenodd"
                                clipRule="evenodd"></path>
                        </svg>
                    </div>
                    <div
                        onMouseLeave={handleMouseLeave}
                        onClick={() =>
                            handleClick(
                                "Turno pendiente de confirmación al contacto"
                            )
                        }
                        className="flex items-center justify-center w-8 h-6 text-white bg-orange-400 rounded-lg cursor-pointer">
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM8.24992 4.49999C8.24992 4.9142 7.91413 5.24999 7.49992 5.24999C7.08571 5.24999 6.74992 4.9142 6.74992 4.49999C6.74992 4.08577 7.08571 3.74999 7.49992 3.74999C7.91413 3.74999 8.24992 4.08577 8.24992 4.49999ZM6.00003 5.99999H6.50003H7.50003C7.77618 5.99999 8.00003 6.22384 8.00003 6.49999V9.99999H8.50003H9.00003V11H8.50003H7.50003H6.50003H6.00003V9.99999H6.50003H7.00003V6.99999H6.50003H6.00003V5.99999Z"
                                fill="currentColor"
                                fillRule="evenodd"
                                clipRule="evenodd"></path>
                        </svg>
                    </div>
                    <div
                        onMouseLeave={handleMouseLeave}
                        onClick={() =>
                            handleClick("Turno ya confirmado al contacto")
                        }
                        className="flex items-center justify-center w-8 h-6 text-white bg-teal-400 rounded-lg cursor-pointer">
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM8.24992 4.49999C8.24992 4.9142 7.91413 5.24999 7.49992 5.24999C7.08571 5.24999 6.74992 4.9142 6.74992 4.49999C6.74992 4.08577 7.08571 3.74999 7.49992 3.74999C7.91413 3.74999 8.24992 4.08577 8.24992 4.49999ZM6.00003 5.99999H6.50003H7.50003C7.77618 5.99999 8.00003 6.22384 8.00003 6.49999V9.99999H8.50003H9.00003V11H8.50003H7.50003H6.50003H6.00003V9.99999H6.50003H7.00003V6.99999H6.50003H6.00003V5.99999Z"
                                fill="currentColor"
                                fillRule="evenodd"
                                clipRule="evenodd"></path>
                        </svg>
                    </div>
                </div>
                <div className="px-4 py-2 mb-4 rounded-md text-blue-consulta-800 bg-blue-consulta-100 sm:hidden">
                    <p className="text-sm">
                        <strong>Nota:</strong> Para agendar un turno, toca en un
                        día disponible por un segundo. Para bloquear un día,
                        selecciona "Editar consultorio" en la esquina superior
                        derecha.
                    </p>
                </div>
                <BigCalendar
                    longPressThreshold={100}
                    localizer={localizer}
                    events={myEventsList}
                    startAccessor="start"
                    endAccessor="end"
                    views={views}
                    defaultView="day"
                    selectable
                    messages={{
                        next: "Siguiente",
                        previous: "Anterior",
                        today: "Hoy",
                        month: "Mes",
                        week: "Semana",
                        day: "Día",
                        agenda: "Agenda",
                        date: "Fecha",
                        time: "Hora",
                        event: "Evento",
                        showMore: renderShowMore,
                    }}
                    formats={{
                        dayHeaderFormat: (date) => {
                            return dayjs(date).format("dddd - DD/MM");
                        },
                    }}
                    components={components}
                    dayPropGetter={blockDayStyle}
                    onSelectSlot={onSelectSlot}
                    onSelectEvent={onSelectEvent}
                />
            </div>
        </div>
    );
};
